import React, { useState, useEffect, useRef } from "react";
import { loadModules } from "esri-loader";
import Loader from "react-loader-spinner";
import "./map.css";
export default function WebMapView({ update, data }) {
  const mapRef = useRef();
  const [zoom, setZoom] = useState(8);
  const [left, setLeft] = useState(-121.377);
  const [right, setRight] = useState(38.6);
  const [globalMap, setGlobalMap] = useState("");
  const [globalGraphic, setGlobalGraphic] = useState("");
  const [propData, setPropData] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(
      ["esri/Map", "esri/views/MapView", "esri/widgets/Search", "esri/Graphic"],
      {
        css: true,
      }
    ).then(([ArcGISMap, MapView, Search, Graphic]) => {
      const map = new ArcGISMap({
        basemap: "streets-night-vector",
      });

      // load the map view at the ref's DOM node
      const view = new MapView({
        container: mapRef.current,
        map: map,
        center: [left, right],
        zoom: zoom,
        popup: {
          actions: [],

          dockEnabled: true,
          dockOptions: {
            buttonEnabled: false,
            breakpoint: false,
            position: "bottom-right",
          },
        },
      });

      setGlobalMap(view);
      var graphic = new Graphic({
        symbol: {
          type: "simple-marker",
          style: "circle",
          color: [252, 186, 3],
          size: "16px",
          outline: {
            color: "#fcba03",
            width: 3,
          },
        },
      });
      setGlobalGraphic(graphic);

      function showCoordinates(pt) {
        update(pt.latitude.toFixed(6), pt.longitude.toFixed(6));
      }

      const searchWidget = new Search({
        view: view,
        container: "list",
      });
      view.ui.add(searchWidget, {
        position: "top-right",
        index: 0,
      });

      view.watch("stationary", function (isStationary) {
        showCoordinates(view.center);
        setLoading(false);
      });
      view.watch("updating", () => {
        setLoading(true);
      });
      return () => {
        if (view) {
          // destroy the map view
          view.container = null;
        }
      };
    });
  }, []);

  return (
    <div>
      <div className="container">
        <div className="list">
          {data.map((item, index) => (
            <button
              key={index}
              className="button"
              onClick={() => {
                globalMap.goTo({
                  center: [item.venue.location.lon, item.venue.location.lat],
                  zoom: 12,
                });
                setPropData(data);
                globalMap.graphics.remove();

                let point = {
                  type: "point",
                  longitude: item.venue.location.lon.toFixed(4),
                  latitude: item.venue.location.lat.toFixed(4),
                  spatialReference: globalMap.spatialReference,
                };
                globalGraphic.geometry = point;
                globalMap.graphics.add(globalGraphic);

                globalMap.popup.open({
                  // title: item.title + "\n" + " address: " + item.venue.address,
                  content: `<div style=" font-size: 1.2em;background:orange;margin:0;padding:5px" >
                  <h3>${item.title}</h3>
                  <strong style="margin:0">${item.venue.address}</strong>
                  <p style="margin:0">Event Type:<strong> ${item.type}</strong></p>
                  <p style="margin:0">Event Date: <strong>${item.datetime_local}</strong></p>
                  <a style="text-align: center; text-decoration:none;background:orange; color:black" target="blank" href="${item.venue.url}">For More Info and Tickets Click Here</a>
                  </div>`,
                  // content: `  <a style="text-align: center; text-decoration:none;background:orange; color:black" target="blank" href="${item.venue.url}">For More Info and Tickets Click Here</a>`,
                });
              }}
            >
              <strong className="text">{item.title} </strong>
              <div>
                <p style={{ display: "none" }}> {item.datetime_utc}</p>
              </div>
            </button>
          ))}
        </div>

        <div id="mapsama" className="webmap" ref={mapRef} />
      </div>
    </div>
  );
}

// view.on("click", function (evt) {
//   showCoordinates(view.toMap({ x: evt.x, y: evt.y }));
// });
